
  <ng-container *ngIf="task.status.value == WorkflowTaskStatus.TASK_STATUS_NOT_STARTED else errorStatus">
    <ng-container
            *ngIf="task.trigger.type.value === WorkflowTaskTriggerType.WORKFLOW_TASK_TRIGGER_DATETIME else statusDefault">
      <app-datetime-summary-field
              [datetime]="task.trigger.time"
              label="Déclenchement prévu le"></app-datetime-summary-field>
    </ng-container>
  </ng-container>


<ng-template #errorStatus>
  <app-summary-field *ngIf="task.status.value == WorkflowTaskStatus.TASK_STATUS_ERROR else startedStatus">
    <ion-text color="danger">{{task.status.label}}</ion-text>
    à
    <app-datetime-label [date]="task.executionEnd"></app-datetime-label>
    <span *ngIf="errorLabel">: {{errorLabel}}</span>
  </app-summary-field>
</ng-template>

<ng-template #startedStatus>
  <app-summary-field *ngIf="task.status.value == WorkflowTaskStatus.TASK_STATUS_IN_PROGRESS else doneStatus">
    {{task.status.label}} à
    <app-datetime-label [date]="task.executionStart"></app-datetime-label>
  </app-summary-field>
</ng-template>

<ng-template #doneStatus>
  <app-summary-field *ngIf="task.status.value == WorkflowTaskStatus.TASK_STATUS_DONE else statusDefault">
    <ion-text color="success">{{task.status.label}}</ion-text>
    à
    <app-datetime-label [date]="task.executionEnd"></app-datetime-label>
  </app-summary-field>
</ng-template>


<ng-template #statusDefault>
  <app-summary-field>{{task.status.label}}</app-summary-field>
</ng-template>